module.exports = __webpack_public_path__ + "img/find.8dd81cb9.svg";